import React from 'react';
import { Box, Typography, FormGroup, FormControlLabel, Checkbox, Chip, Alert } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';
import { Role } from '../../../types/role.types';

interface WizardStep2Props {
  roleIds: string[];
  roles: Role[];
  onToggleRole: (roleId: string) => void;
  error?: string;
}

const WizardStep2: React.FC<WizardStep2Props> = ({ roleIds, roles, onToggleRole, error }) => {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.5 }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Roles asignados
        </Typography>
        <Chip
          label={`${roleIds.length} seleccionado(s)`}
          size="small"
          sx={{
            backgroundColor: '#10b981',
            color: 'white',
            fontWeight: 600,
          }}
        />
      </Box>
      <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
        Selecciona los roles que tendrá el usuario
      </Typography>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {roles.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            backgroundColor: 'rgba(245, 158, 11, 0.06)',
            borderRadius: '8px',
            padding: '10px 14px',
          }}
        >
          <InfoIcon sx={{ fontSize: 18, color: '#f59e0b', mt: '2px', flexShrink: 0 }} />
          <Typography variant="body2" sx={{ color: '#f59e0b', lineHeight: 1.5 }}>
            No hay roles disponibles. Crea roles antes de continuar.
          </Typography>
        </Box>
      ) : (
        <FormGroup sx={{ gap: 1.5 }}>
          {roles.map((role) => {
            const isSelected = roleIds.includes(role.id);
            return (
              <Box
                key={role.id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 1.5,
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: isSelected ? '#10b981' : 'divider',
                  backgroundColor: isSelected ? 'rgba(16, 185, 129, 0.08)' : 'transparent',
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={isSelected}
                      onChange={() => onToggleRole(role.id)}
                      sx={{ mr: 1 }}
                    />
                  }
                  label={
                    <Box>
                      <Typography variant="body1" sx={{ fontWeight: 600 }}>
                        {role.name}
                      </Typography>
                      {role.description && (
                        <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                          {role.description}
                        </Typography>
                      )}
                    </Box>
                  }
                />
                {role.isSystem && (
                  <Chip
                    label="Sistema"
                    size="small"
                    sx={{
                      backgroundColor: 'rgba(148, 163, 184, 0.2)',
                      color: 'text.secondary',
                      fontWeight: 600,
                    }}
                  />
                )}
              </Box>
            );
          })}
        </FormGroup>
      )}
    </Box>
  );
};

export default WizardStep2;
